import { createContext, useContext, useState, ReactNode } from 'react';
import { CharacterInCreation } from './characterTypes';

interface CharacterContextType {
  character: CharacterInCreation;
  updateCharacter: (updates: Partial<CharacterInCreation>) => void;
}

const CharacterContext = createContext<CharacterContextType | undefined>(
  undefined,
);

export const CharacterContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [character, setCharacter] = useState<CharacterInCreation>({});

  const updateCharacter = (updates: Partial<CharacterInCreation>) => {
    setCharacter((prev) => ({ ...prev, ...updates }));
  };

  return (
    <CharacterContext.Provider value={{ character, updateCharacter }}>
      {children}
    </CharacterContext.Provider>
  );
};

export const useCharacter = () => {
  const context = useContext(CharacterContext);
  if (!context) {
    throw new Error('useCharacter must be used within a CharacterProvider');
  }
  return context;
};
